import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui';

export default function DescribeBox({ value, onChange, placeholder, label }) {
  const navigate = useNavigate();
  const text = value.trim();
  const plan = () => {
    if (!text) return;
    navigate(`/tasks/new?describe=${encodeURIComponent(text)}`);
  };
  const fieldId = 'describe-box-input';

  return (
    <div className="flex flex-col gap-3">
      {label && (
        <label htmlFor={fieldId} className="text-sm font-semibold text-ink">
          {label}
        </label>
      )}
      <textarea
        id={fieldId}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) {
            e.preventDefault();
            plan();
          }
        }}
        placeholder={placeholder}
        aria-label={label ? undefined : placeholder}
        className="w-full min-h-[96px] bg-card border-1.5 border-ink rounded-[14px] p-3 text-ink placeholder:text-pencil focus-ring"
      />
      <div>
        <Button variant="primary" disabled={!text} onClick={plan}>
          Plan it →
        </Button>
      </div>
    </div>
  );
}
